import { useSetTaskCalendarOverride as _useSetTaskCalendarOverride } from '@griply/hooks';
import { getTaskCalendarOverrideWrites } from '@griply/services';
import { useGoals } from 'features/goals';
import { useSetTaskCalendarOverrideMutation } from 'shared/hooks/queries/use-set-task-calendar-override-mutation';
import { useEntityLinks } from 'shared/hooks/use-entity-links';

import { useExternalCalendarConnections } from './use-external-calendar-connections';

export const useSetTaskCalendarOverride = () => {
  const { mutate } = useSetTaskCalendarOverrideMutation();
  const connections = useExternalCalendarConnections();
  const links = useEntityLinks();
  const goals = useGoals();

  return _useSetTaskCalendarOverride({
    connections,
    goals,
    links,
    buildWrites: getTaskCalendarOverrideWrites,
    mutate,
  });
};
